import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

/**
 * Every seeded model ships with placeholder pricing and no EU evidence. This notice stays
 * on the page until an admin has verified each figure — showing an unchecked price as if it
 * were real is how a cost forecast quietly becomes wrong.
 */
export const UnverifiedPricingNotice: FunctionComponent<{ unverifiedCount: number }> = ({
	unverifiedCount,
}) => {
	const { t } = useTranslation();

	if (!unverifiedCount) {
		return null;
	}

	return (
		<div className="rounded-card border border-status-warning bg-status-warning-light px-4 py-3">
			<p className="text-sm font-semibold text-warning-ink">
				{t("mediaPresets.unverifiedPricing.title", { count: unverifiedCount })}
			</p>
			<p className="mt-1 text-xs text-warning-ink">
				{t("mediaPresets.unverifiedPricing.description")}
			</p>
		</div>
	);
};
